/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  MetaCategorySuggestionControllerGetQueueItemQueryResponse,
  MetaCategorySuggestionControllerGetQueueItemPathParams,
  MetaCategorySuggestionControllerGetQueueItem401,
  MetaCategorySuggestionControllerGetQueueItem404,
} from '../../types/MetaCategorySuggestionControllerGetQueueItem.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { metaCategorySuggestionGetQueueItem } from '../../methods/metaCategorySuggestionGetQueueItem.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const metaCategorySuggestionGetQueueItemQueryKey = (
  queueId: MetaCategorySuggestionControllerGetQueueItemPathParams['queueId'],
) => [{ url: '/api/user/telegram/category/meta/suggestions/queue/:queueId', params: { queueId: queueId } }] as const;

export type MetaCategorySuggestionGetQueueItemQueryKey = ReturnType<typeof metaCategorySuggestionGetQueueItemQueryKey>;

export function metaCategorySuggestionGetQueueItemQueryOptions(
  queueId: MetaCategorySuggestionControllerGetQueueItemPathParams['queueId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = metaCategorySuggestionGetQueueItemQueryKey(queueId);
  return queryOptions<
    MetaCategorySuggestionControllerGetQueueItemQueryResponse,
    ResponseErrorConfig<
      MetaCategorySuggestionControllerGetQueueItem401 | MetaCategorySuggestionControllerGetQueueItem404
    >,
    MetaCategorySuggestionControllerGetQueueItemQueryResponse,
    typeof queryKey
  >({
    enabled: !!queueId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return metaCategorySuggestionGetQueueItem(queueId, config);
    },
  });
}

/**
 * {@link /api/user/telegram/category/meta/suggestions/queue/:queueId}
 */
export function useMetaCategorySuggestionGetQueueItem<
  TData = MetaCategorySuggestionControllerGetQueueItemQueryResponse,
  TQueryData = MetaCategorySuggestionControllerGetQueueItemQueryResponse,
  TQueryKey extends QueryKey = MetaCategorySuggestionGetQueueItemQueryKey,
>(
  queueId: MetaCategorySuggestionControllerGetQueueItemPathParams['queueId'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        MetaCategorySuggestionControllerGetQueueItemQueryResponse,
        ResponseErrorConfig<
          MetaCategorySuggestionControllerGetQueueItem401 | MetaCategorySuggestionControllerGetQueueItem404
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? metaCategorySuggestionGetQueueItemQueryKey(queueId);

  const query = useQuery(
    {
      ...metaCategorySuggestionGetQueueItemQueryOptions(queueId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      MetaCategorySuggestionControllerGetQueueItem401 | MetaCategorySuggestionControllerGetQueueItem404
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
